const translations = {
    en: { 
        home: "Home",
        getUdid: 'Get UDID',
        buyCert: "Buy Certificate",
        about: 'iDeploy is a project to create direct links to the installation of applications on iOS and iPad OS is an initiative aimed at simplifying the process of downloading and installing applications on devices running iOS and iPad operating systems.',
        descriptionUdid: 'The UDID is unique for each iPhone/iPad/iPod. UDID has one purpose. A unique number for registration in the Apple Developer portal.',
        search: 'Search',
        fa_search: 'Device search',
        fa_search_p: 'Enter the device UDID to search and check the status',
        search_placeholder: 'Enter the device UDID (for example: 00008120-0009353426E3C01E)',
        select_app: 'Select an application',
        select_sign_app: 'Select a signature application',
        development: 'In development',
        download_cert: '📱 Downloading the certificate',
        cert_ready: 'The certificate is ready for download',
        device_info: 'Device information',
        name: 'Name',
        reg_date: 'Registration date',
        status: 'Status',
        ready: "Ready",
        download_cert_btn: 'Download certificate',
        remainingText: 'Time left',
        signApp: 'Sign application',
        instruction: 'Instructions',
        clickToDownload: 'Click to download', 
        foundCert: 'Certificates found',

    },
    ru: { 
        home: "Главная",
        getUdid: 'Получить UDID',
        buyCert: "Купить сертификат",
        about: 'iDeploy - это проект по созданию прямых ссылок на установку приложений на iOS и iPad OS - это инициатива, направленная на упрощение процесса загрузки и установки приложений на устройства под управлением операционных систем iOS и iPad.',
        descriptionUdid: 'UDID уникален для каждого iPhone/iPad/iPod. У UDID есть используется только  для регистрации на портале Apple Developer.',
        search: 'Проверить',
        fa_search: 'Поиск устройства',
        fa_search_p: 'Введите UDID устройства для поиска и проверки статуса',
        search_placeholder: 'Введите UDID устройства (например: 00008120-0009353426E3C01E)',
        expired: "Истек",
        extended: "Регистрация продлена",
        ready: "Готов",
        waiting: "Ожидание",
        revoked: "Отозван", 
        select_app: 'Выберите приложение',
        select_sign_app: 'Выберите приложение для подписи',
        development: 'В разработке',
        download_cert: '📱 Скачивание сертификата',
        cert_ready: 'Сертификат готов к скачиванию',
        device_info: 'Информация об устройстве',
        name: 'Имя',
        reg_date: 'Дата регистрации',
        status: 'Статус',
        download_cert_btn: 'Скачать сертификат',
        remainingText: 'Осталось времени',
        signApp: 'Подписать приложение',
        instruction: 'Инструкция',
        clickToDownload: 'Нажмите для скачивания',
        foundCert: 'Найдено сертификатов',

    },
}
export default translations